import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import PEnterText from 'src/components/ModalDialogMUI6/styled/PEnterText';
import DivForm from 'src/components/ModalDialogMUI6/styled/DivForm';
import GridContainer from 'src/components/ModalDialogMUI6/styled/GridContainer';
import Spinner from 'src/components/Spinner/Spinner';
import { ROUTES } from 'src/constants';

function FormCallingYouToConnectYouWith({
  contact,
  loading,
  onCloseModal,
  onSubmitForm = null,
  onSubmitFormRequest = () => {},
}) {
  const history = useHistory();
  const {
    id,
  } = contact || {};

  // I anticipate the possibility of adding functionality to the form in the future.
  const initialValues = {
  };

  const validationSchema = Yup.object().shape({
  });

  const onSubmit = async (values, {
    resetForm,
    setStatus,
    setSubmitting
  }) => {
    if (onSubmitForm) {
      onSubmitForm(id, values, resetForm, setStatus, setSubmitting);
      return;
    }

    const doWhenTry = () => {
      resetForm();
      setStatus({ success: true });
      setSubmitting(false);
      onCloseModal('');
    };

    const doWhenCatch = () => {
      setStatus({ success: false });
      setSubmitting(false);
    };

    onSubmitFormRequest(id, values, doWhenTry, doWhenCatch);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const {
    handleSubmit,
  } = formik || {};

  const handleLinkClick = () => {
    onCloseModal('');
    history.push(ROUTES.APP_ACCOUNT);
    // Scroll to CP Voice Calling section after navigation
    setTimeout(() => {
      const element = document.getElementById('section-cp-voice-calling');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);
  };

  return (
    <form
      id="formCallingYouToConnectYouWith"
      onSubmit={handleSubmit}
    >
      <DivForm
        className="padding-top-bottom-v1 padding-left-right-v1"
      >
        <Spinner
          loading={loading}
          positionType="absolute"
        />
        <GridContainer
          className="first-item"
          rowSpacing={2}
        >
          <Grid
            xs={12}
            item
          >
            <PEnterText>
              To change which number CP uses to call you at, please go to
              <Box
                component="span"
                sx={{
                  display: 'block',

                  '& > a': {
                    fontWeight: '500',
                    color: 'inherit',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                  },
                }}
              >
                <Link
                  component="a"
                  onClick={handleLinkClick}
                >
                  Account & General Settings
                  {' > '}
                  Your Info tab
                </Link>
              </Box>
            </PEnterText>
          </Grid>
        </GridContainer>
      </DivForm>
    </form>
  );
}

FormCallingYouToConnectYouWith.propTypes = {
  contact: PropTypes.object.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onSubmitForm: PropTypes.func,
  onSubmitFormRequest: PropTypes.func,
};

export default FormCallingYouToConnectYouWith;
